// Píxel de ChatGPT Ads (OpenAI): se carga SIEMPRE, sin esperar consentimiento
// de cookies (decisión del cliente: los píxeles no se bloquean por el banner).

declare global {
  interface Window {
    oaiq?: ((...args: unknown[]) => void) & { q?: unknown[] };
    __vibraOaiqLoaded?: boolean;
  }
}

const OAIQ_PIXEL_ID = "Sehb7QreNpNefjNde994b5";

function loadOaiqScript() {
  if (typeof window === "undefined") return;
  if (window.__vibraOaiqLoaded) return;
  window.__vibraOaiqLoaded = true;

  // Snippet oficial de OpenAI, embebido para cargar inmediatamente.
  /* eslint-disable */
  (function (w: any, d: Document, s: string, u: string) {
    if (w.oaiq) return;
    const q: any = function () {
      q.q.push(arguments);
    };
    q.q = [];
    w.oaiq = q;
    const j = d.createElement(s) as HTMLScriptElement;
    j.async = true;
    j.src = u;
    const f = d.getElementsByTagName(s)[0];
    f.parentNode?.insertBefore(j, f);
  })(window, document, "script", "https://bzrcdn.openai.com/sdk/oaiq.min.js");
  /* eslint-enable */

  window.oaiq?.("init", { pixelId: OAIQ_PIXEL_ID });
}

export function initOaiqTracking() {
  if (typeof window === "undefined") return;
  loadOaiqScript();
}

export function measure(
  event: string,
  data?: Record<string, unknown>,
  options?: Record<string, unknown>,
) {
  if (typeof window === "undefined") return;
  try {
    if (typeof window.oaiq !== "function") loadOaiqScript();
    window.oaiq?.("measure", event, data ?? {}, options ?? {});
  } catch {
    /* nunca romper la página por el píxel */
  }
}
